import { LineItem } from "@/DataTypes";

export function validateSizing(workingItem: LineItem) {
	if (!workingItem.sizeSelections && !workingItem.specialSizeSelections) {
		return false;
	}

	let total = 0;
	let quantities: number[] = [];

	//loop through sizeData and grab each quantity array
	if (workingItem.sizeSelections && workingItem.sizeSelections.length > 0) {
		workingItem.sizeSelections.forEach((obj) => {
			if (obj.quantity) {
				quantities = [...quantities, obj.quantity];
			}
		});
	}
	//loop through special sizing and grab each quantity
	if (workingItem.specialSizeSelections && workingItem.specialSizeSelections.length > 0) {
		workingItem.specialSizeSelections.forEach((obj) => {
			if (obj.quantity !== null) {
				quantities.push(obj.quantity);
			}
		});
	}

	//calculate total quantities
	total = quantities
		.map((i) => (typeof i !== "string" ? i : parseInt(i)))
		.reduce((a, b) => a + b, 0);

	return total === workingItem.quantity;
}
